// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1isAy","modalForm":"UpgradeEpcsModal_modalForm__1BIcX","modalFooter":"UpgradeEpcsModal_modalFooter__3lm7K"};